module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "github-corner",
    attrs: {
      "href": "https://github.com/wangdahoo/vswipe",
      "aria-label": "View source on Github"
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "#70B7FD",
      "color": "#fff",
      "position": "absolute",
      "top": "0",
      "border": "0",
      "right": "0"
    },
    attrs: {
      "width": "80",
      "height": "80",
      "viewBox": "0 0 250 250",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"
    }
  }), _c('path', {
    staticClass: "octo-arm",
    staticStyle: {
      "transform-origin": "130px 106px"
    },
    attrs: {
      "d": "M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2",
      "fill": "currentColor"
    }
  }), _c('path', {
    staticClass: "octo-body",
    attrs: {
      "d": "M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('swipe', {
    ref: "mySwipe",
    staticStyle: {
      "max-width": "500px",
      "margin": "0 auto"
    }
  }, [_c('swipe-item', [_c('b', [_vm._v("0")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("3")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("4")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("5")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("6")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("7")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("8")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("9")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("10")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("11")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("12")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("13")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("14")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("15")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("16")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("17")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("18")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("19")])]), _vm._v(" "), _c('swipe-item', [_c('b', [_vm._v("20")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }, [_vm._v("prev")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("next")])]), _vm._v(" "), _c('ul', [_c('li', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("Examples:")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/scrolling"
    }
  }, [_vm._v("Scrolling Content")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fullscreen"
    }
  }, [_vm._v("Fullscreen")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/dynamic"
    }
  }, [_vm._v("Dynamic Swipe Items")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "code-name"
  }, [_vm._v("\n    VSwipe "), _c('sup', [_vm._v("1.0")]), _vm._v(" "), _c('p', [_vm._v("\n      Brad Birdsall's Swipe.js as a Vue component.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7285f968"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/Hello.vue
// module id = 31
// module chunks = 0